module.exports = __webpack_public_path__ + "static/img/bk_forest.1ea00b7f.jpg";